import { j as r } from "../accordion/Accordion-CrPiD_81.mjs";
import { forwardRef as u } from "react";
import { S as d } from "../typography/Typography-qfbU_T11.mjs";
const b = u(({ className: a = "", crumbs: s, render: c, ...m }, i) => /* @__PURE__ */ r.jsx("nav", { className: `rds-breadcrumb ${a}`, ref: i, ...m, children: /* @__PURE__ */ r.jsx(d, { children: /* @__PURE__ */ r.jsx("ol", { className: "rds-breadcrumb__list", children: s.map(({ name: e, href: l }, n) => {
  const t = n === s.length - 1;
  return /* @__PURE__ */ r.jsx(
    "li",
    {
      className: `rds-breadcrumb__list-item ${s.length >= 4 ? "rds-breadcrumb__list-item--truncate" : ""}`,
      "data-testid": `rds-breadcrumb-${e}`,
      "aria-current": t ? "page" : "false",
      children: c(e, l, t)
    },
    e
  );
}) }) }) })), _ = ({ children: a }) => /* @__PURE__ */ r.jsx(d, { className: "rds-breadcrumb__current", children: a });
b.displayName = "Breadcrumb";
export {
  b as B,
  _ as a
};
